import { GoalIdSchema as s } from "@hprofits/shared";
import { PrivilegeEnum as o } from "@hprofits/shared/auth";
import { z as r } from "zod";
import "../common/acl-view.js";
import { ocPrivate as a } from "../common/auth/procedure-builders.js";
import { createCreationResultSchema as i } from "../common/creation-result.js";
import "../common/owner.js";
import { GoalIdParamSchema as u } from "../common/params.js";
import "../common/errors/constants.js";
import { notFoundError as e, alreadyExistsError as m } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as t } from "../swagger/tags.js";
import { RenameGoalSchema as l, CreateGoalSchema as p, GoalsQuerySchema as n, GoalsResponseSchema as h } from "./schemas.js";
const O = {
  goal: {
    /**
     * List goals, newest first.
     */
    findAll: a([o.ReadAdvert]).route({
      method: "GET",
      path: "/goals",
      summary: "List goals",
      tags: [t.GOALS.name]
    }).input(n).output(h).errors({}),
    /**
     * Create a goal
     */
    create: a([o.WriteAdvert]).route({
      method: "POST",
      path: "/goals",
      summary: "Create a goal",
      tags: [t.GOALS.name],
      successStatus: 201
    }).input(p).output(i(s)).errors({
      ...m("The owner already has a goal with this name")
    }),
    /**
     * Rename a goal
     */
    rename: a([o.WriteAdvert]).route({
      method: "PATCH",
      path: "/goals/{goalId}",
      summary: "Rename a goal",
      tags: [t.GOALS.name],
      successStatus: 204
    }).input(l).output(r.void()).errors({
      ...e("Goal not found"),
      ...m("The owner already has a goal with this name")
    }),
    /**
     * Delete a goal
     */
    remove: a([o.WriteAdvert]).route({
      method: "DELETE",
      path: "/goals/{goalId}",
      summary: "Delete a goal",
      tags: [t.GOALS.name],
      successStatus: 204
    }).input(u).output(r.void()).errors({
      ...e("Goal not found")
    })
  }
};
export {
  O as goalContract
};
//# sourceMappingURL=contract.js.map
